module.exports = __webpack_public_path__ + "img/icon-winter.f2751831.png";